export default "__VITE_ASSET__16d3af08__"